// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__qX8o8","fadeContainer":"Loader_fadeContainer__CIE1D"};